import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet} from '@angular/router';
import { filter } from 'rxjs';
import { OrganizationService }  from '../../../core/services/organization.service';
import { TopTabItem, TopTabViewComponent } from '../../../shared/components/top-tab-view/top-tab-view';

@Component({
  selector: 'app-mensa-admin-panel',
  standalone: true,
  imports: [
    RouterOutlet,
    TopTabViewComponent
  ],
  templateUrl: './mensa-admin-panel.html'
})
export class MensaAdminPanelComponent implements OnInit {
  activeTab = 'dashboard';

  operationTabs: TopTabItem[] = [
    { key: 'dashboard', title: 'Dashboard' },
    { key: 'organization', title: 'Organization' },
    { key: 'exam-slot', title: 'Exam Slot' },
    { key: 'student-list', title: 'Student' },
    { key: 'exam-record', title: 'Exam Record' }
  ];

 constructor(
  private router: Router,
  private organizationService: OrganizationService
) {}

 ngOnInit(): void {

  this.organizationService
    .getOrganizations()
    .subscribe({
      next: (organizations) => {

      },
      error: (error) => {
        console.error(
          'Failed to load organizations:',
          error
        );
      }
    });

  this.updateActiveTab(this.router.url);

  this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.updateActiveTab(event.urlAfterRedirects);
    });
}

  onTabSelected(tab: TopTabItem): void {
    this.router.navigate([
      '/mensa-admin/admin-panel',
      tab.key
    ]);
  }

   private updateActiveTab(url: string): void {

      const cleanUrl = url.split('?')[0];

      if (
        cleanUrl.includes('/mensa-admin/admin-panel/exam-record/')
      ) {
        this.activeTab = 'exam-record';
        return;
      }

    const segments = url
      .split('?')[0]
      .split('/')
      .filter(Boolean);

    const currentRoute = segments[segments.length - 1];

    const matchingTab = this.operationTabs.find(
      tab => tab.key === currentRoute
    );

    this.activeTab = matchingTab?.key ?? 'dashboard';
  }
}
